import Hammer from 'hammerjs'
import $ from 'jquery'

const CADENCE = 6000

$(() => {
  let animate = true

  $navItems().click(function () {
    animate = false
    const index = $(this).index()
    displayIndex(index)
  })

  // Swiping left will advance to the next item, moving the
  // virtual pan to the left. It's a little unintuitive why it
  // should work this way until you try it on an actual device.
  hammerManager().on('swipeleft', () => {
    animate = false
    displayIndex(nextIndex())
  })

  hammerManager().on('swiperight', () => {
    animate = false
    displayIndex(previousIndex())
  })

  const displayNext = () => {
    if (!animate) { return }
    displayIndex(nextIndex())
    setTimeout(displayNext, CADENCE)
  }

  setTimeout(displayNext, CADENCE)
})

const hammerManager = () => {
  const manager = new Hammer.Manager($mobileCarousel())

  manager.add(hammerSwipe())
  return manager
}

const hammerSwipe = () =>
  new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL })

const $mobileCarousel = () => document.querySelector('.carousel-mobile')

const $navItems = () => $('.carousel__content__navitem')
const $activeNavItem = () => $('.carousel__content__navitem__selected')
const $titles = () => $('.carousel__title')
const $images = () => $('.carousel__image')
const $descriptions = () => $('.carousel__content__description')

const $nthNavItem = (n) => $(`.carousel__content__navitem:nth-of-type(${n + 1})`)
const $nthTitle = (n) => $(`.carousel__title:nth-of-type(${n + 1})`)
const $nthImage = (n) => $(`.carousel__image:nth-of-type(${n + 1})`)
const $nthDescription = (n) => $(`.carousel__content__description:nth-of-type(${n + 1})`)

const hideAll = () => {
  $navItems()
    .removeClass('carousel__content__navitem__selected')
    .attr('aria-selected', false)

  $titles().addClass('carousel__title__hidden')
  $images().addClass('carousel__image__hidden')
  $descriptions().addClass('carousel__content__description__hidden')
}

const displayIndex = (n) => {
  hideAll()
  $nthNavItem(n).addClass('carousel__content__navitem__selected').attr('aria-selected', true)
  $nthTitle(n).removeClass('carousel__title__hidden')
  $nthImage(n).removeClass('carousel__image__hidden')
  $nthDescription(n).removeClass('carousel__content__description__hidden')
}

const itemCount = () => $('.carousel__content > .carousel__content__navitem').length
const currentIndex = () => $activeNavItem().index()
const nextIndex = () => (currentIndex() + 1) % itemCount()
const previousIndex = () => (currentIndex() - 1 + itemCount()) % itemCount()
